import { httpClient, HttpMethod } from './http-client';
import { PartTypeCategory } from '../@types/partTypeCategory.type';

export const getPartTypeCategories = (): Promise<PartTypeCategory[]> => {
  return httpClient<PartTypeCategory[]>('/partTypeCategories', HttpMethod.Get);
};
